// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","container":"_1O66eQQuM1ItByc-OJkGsI","disabled":"_3EQOUsEYxFu6gaXfPyTOGB"};